import { useState, useEffect } from 'react';
import { formatBalance, InputText, InputSize } from '@ui/src';
import { Balance } from '../../../hoc/statements/types';
import { AccountBalanceTypes } from './types';

import cn from './styles.module.css';
import sharedStyles from '../shared.module.css';

let timeout: NodeJS.Timeout;

const AccountBalance = ({
  balance,
  currenciesList,
  overdraftEnabled,
  setBalances,
  balances,
  updateOverdraftBalanceIsLoading,
  defaultBalance,
  closedBalance,
}: AccountBalanceTypes) => {
  const [overdraftValue, setOverdraftValue] = useState('');

  const onUpdateOverdraftValue = (value: string) => {
    clearTimeout(timeout);

    let nextValue = value;

    if (Number(value) < 0) {
      nextValue = '0';
    }

    setOverdraftValue(nextValue);

    timeout = setTimeout(() => {
      const nextBalances = balances?.map((item) => {
        const result = { ...item };

        if (item.id === balance.id) {
          result.overdraftValue = Number(nextValue);

          if (Number(nextValue) > 0) {
            result.overdraftEnabled = true;
          } else {
            result.overdraftEnabled = false;
          }
        }

        return result;
      });

      setBalances(nextBalances as Balance[]);
    }, 500);
  };

  useEffect(() => {
    if (balance && balance.overdraftValue) {
      setOverdraftValue(balance?.overdraftValue.toString());
    }
  }, [balance]);

  return (
    <div
      className={`${sharedStyles.balanceItem} ${
        closedBalance ? sharedStyles.flexStart : ''
      }`}
    >
      <div className={sharedStyles.balanceItemLeft}>
        <div className={sharedStyles.balanceItemLeftContent}>
          <span>{balance.currencyName}</span>
          <span>
            {formatBalance(
              balance.value,
              currenciesList?.find(
                (currency) => currency.id === balance?.currencyId,
              ),
            )}
          </span>
        </div>
        {overdraftEnabled &&
          defaultBalance?.overdraftEnabled &&
          defaultBalance?.value < 0 && (
            <div
              className={cn.usedOverdraft}
            >{`Remaining overdraft: ${formatBalance(
              // eslint-disable-next-line no-nested-ternary
              defaultBalance?.value < 0
                ? (defaultBalance?.overdraftValue as number) -
                    Math.abs(defaultBalance?.value) <
                  0
                  ? 0
                  : (defaultBalance?.overdraftValue as number) -
                    Math.abs(defaultBalance?.value)
                : (defaultBalance?.overdraftValue as number),
              currenciesList?.find(
                (currency) => currency.id === balance?.currencyId,
              ),
            )} ${
              currenciesList?.find(
                (currency) => currency.id === balance?.currencyId,
              )?.name
            }`}</div>
          )}
      </div>
      {closedBalance && (
        <div
          className={`${sharedStyles.balanceItemLeft} ${sharedStyles.closedBalance}`}
        >
          <div className={sharedStyles.balanceItemLeftContent}>
            {closedBalance}
          </div>
        </div>
      )}
      {overdraftEnabled && (
        <InputText
          name="overdraftValue"
          value={overdraftValue}
          placeholder="0.00"
          labelClassName={cn.overdraftValue}
          onChange={(e) => onUpdateOverdraftValue(e.target.value)}
          size={InputSize.SMALL}
          currency={currenciesList?.find(
            (item) => item.id === balance.currencyId,
          )}
          disabled={updateOverdraftBalanceIsLoading}
          amountInput
        />
      )}
    </div>
  );
};

export default AccountBalance;
